import React from "react";
import "../commons/AddButton.css";

const AddButton = ({ text }) => {
  return (
    <div className="text-center mt-2 mb-3">
      <button type="submit" className="btn btn-secondary">
        {" "}
        {text}{" "}
      </button>
    </div>
  );
};

export default AddButton;
